import axios from 'axios'
import { reactLocalStorage } from 'reactjs-localstorage';
import { isMerchant } from './Admin';
// import commonStore from "../stores/CommonStore";
// import { clearLS } from './functions/functions';
import { getUrlCourtCode, getUrlCourtId } from './Court';

const queryParser = params => {
  let queryParams = ''
  for (let key in params) {
    if (!queryParams) {
      queryParams = queryParams.concat(`?${key}=${params[key]}`)
    } else {
      queryParams = queryParams.concat(`&${key}=${params[key]}`)
    }
  }
  return queryParams
}

// if (getCookie('ideal_current_token')) {
//   token = getCookie('ideal_current_token');
// }
const getToken = () => {
  let token = ''
  if (reactLocalStorage.get('user_token')) {
    token = reactLocalStorage.get('user_token');
  }
  // if (!token) {
  //   reactLocalStorage.clear()
  //   window.location.href = "/login"
  // }
  return token;
}
const setMerchant = () => {
  let merchantId = isMerchant()
  if (merchantId) { return { 'merchant-id': merchantId } }
  return {}
}
const setPlace = () => {
  let placeId = getUrlCourtId()
  if (placeId) { return { 'place-id': placeId }}
  return {}
}
const responseError = (error, reject) => {
  if (error && error.response && error.response.data) {
    // jika menu diset custom permission tapi user role masih forbidden
    if (error.response.data.errorCode === 40301) {
      // commonStore.showErrorMessage(error.response.data.message);
      window.location.href = `/${getUrlCourtCode()}/dashboard`;
    }
    // check region
    if (error.response.data.errorCode === 22002) {
      // commonStore.showErrorMessage(error.response.data.message);
      window.location.href = `/${getUrlCourtCode()}/dashboard`;
    }
    if (error.response.data.statusCode === 403) {

    }
    if (error.response.data.statusCode === 405) {
      sessionStorage.clear()
      localStorage.clear()
      reactLocalStorage.clear()
      window.location.href = "/login"
    }
  }

  if (error.response) {
    reject(error);
  } else {
    let err = {
      response: {
        data: `Can't Connect to Server!`
      }
    }
    reject(err);
  }
}

const defaultHeaders = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*'
  // 'Accept': 'application/json'
}

const getHeaders = () => ({
  ...defaultHeaders,
  ...setMerchant(),
  'x-access-token': getToken(),
  ...setPlace()
})

const makeRequest = (method, url, params, data, cancelToken, responseType) => {
  return new Promise((resolve, reject) => {
    const config = {
      url: ['GET', 'PUT', 'PATCH', 'DELETE'].includes(method) ? url + queryParser(params) : url,
      method,
      headers: getHeaders(),
      ...(data && { data }),
      ...(cancelToken && { cancelToken: cancelToken.token }),
      ...(responseType && { responseType })
    }

    axios.request(config)
      .then(response => resolve(response.data))
      .catch(error => responseError(error, reject))
  })
}

const Axios = {
  Get: ({ url, params, responseType, cancelToken }) =>
    makeRequest('GET', url, params, null, cancelToken, responseType),
  Post: ({ url, params, data }) =>
    makeRequest('POST', url, params, data),
  Put: ({ url, params, data }) =>
    makeRequest('PUT', url, params, data),
  Patch: ({ url, params, data }) =>
    makeRequest('PATCH', url, params, data),
  Delete: ({ url, params, data }) =>
    makeRequest('DELETE', url, params, data)
}

export default Axios
